var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 221,
    viewBox: "0 0 220 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110.5,
    r: 110,
    fill: "#FFECF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.103 154.828C147.436 154.629 147.751 154.409 148.047 154.168C149.821 153.713 151 151.777 151 148.797V148.006L151 147.961V119.5L151 119.5V117.111C151 112.508 148.186 107.16 144.712 105.159L97.8601 78.2304C96.4981 77.4674 95.2375 77.3216 94.2081 77.7038L94.2072 77.6976L94.1773 77.7154C93.8441 77.8431 93.5356 78.0265 93.256 78.2625L73.5566 89.961L91.5723 108.043V114.642C91.5723 119.245 94.3867 124.593 97.8601 126.594L128.148 144.003V166.154L147.103 154.828Z",
    fill: "#E31D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.185 165.753L77.2767 138.825C73.8033 136.835 71 131.487 71 126.884V95.1747C71 90.5718 73.8033 88.5038 77.2767 90.4495L124.185 117.389C127.647 119.379 130.461 124.727 130.461 129.33V161.017C130.461 165.619 127.647 167.743 124.185 165.753Z",
    fill: "#FB64BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3864 93.618C100.155 93.618 103.21 91.8608 103.21 89.6933C103.21 87.5257 100.155 85.7686 96.3864 85.7686C92.6177 85.7686 89.5625 87.5257 89.5625 89.6933C89.5625 91.8608 92.6177 93.618 96.3864 93.618Z",
    fill: "#00A497"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.379 110.007C131.147 110.007 134.203 108.25 134.203 106.082C134.203 103.914 131.147 102.157 127.379 102.157C123.61 102.157 120.555 103.914 120.555 106.082C120.555 108.25 123.61 110.007 127.379 110.007Z",
    fill: "#00A497"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5979 87.5269V67.4561C96.5979 57.6832 103.489 53.7251 111.988 58.5615C120.487 63.4424 127.378 75.3277 127.378 85.0895V103.16",
    stroke: "#19D3C5",
    strokeWidth: 10.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLock);
export default __webpack_public_path__ + "static/media/imgLock.1965627f34b9f236f391d3c6010ded76.svg";
export { ForwardRef as ReactComponent };